<template>
    <div class="row-center selectTime">
        <el-date-picker
        :editable="false"
        :picker-options="pickerOptions"
        :clearable="false"
        class="dateSelect"
        v-model="date"
        :format="radio === 'week' ? 'yyyy 第 WW 周' : ''"
        :type="radio === 'day' ? 'date' : radio"
        :placeholder="new Date().toLocaleDateString().replace(/\//g, '-')"
        >
        </el-date-picker>

        <!-- <div class="radio">
            <el-radio v-model="radio" label="year">年</el-radio>
            <el-radio v-model="radio" label="month">月</el-radio>
            <el-radio v-model="radio" label="week">周</el-radio>
            <el-radio v-model="radio" label="day">日</el-radio>
        </div> -->
        <el-button plain class="btn per" @click="perD" v-if="radio === 'day'" >
            上一日
        </el-button>
        <el-button plain class="btn per" @click="perM" v-if="radio === 'month'" >
            上一月
        </el-button>
        <el-button plain class="btn per" @click="perW" v-if="radio === 'week'">
            上一周
        </el-button>
        <el-button plain class="btn per" @click="perY" v-if="radio === 'year'">
            上一年
        </el-button>
        <el-button
            class="btn next"
            plain
            @click="nextD"
            v-if="radio === 'day'"
            :disabled="nextDayDisabled"
            >下一日
        </el-button>
        <el-button
            class="btn next"
            plain
            @click="nextM"
            v-if="radio === 'month'"
            :disabled="nextDayDisabled">
            下一月
        </el-button>
        <el-button
            class="btn next"
            plain
            @click="nextW"
            v-if="radio === 'week'"
            :disabled="nextDayDisabled"
            >
            下一周
        </el-button>
        <el-button
            class="btn next"
            plain
            @click="nextY"
            v-if="radio === 'year'"
            :disabled="nextDayDisabled"
            >下一年
        </el-button>
    </div>
</template>

<script>
import {
	perDay,
	perMonth,
	perYear,
	nextDay,
	nextMonth,
	nextYear,
	dateFormat,
	dateToString,
	dayStart,
	dayEnd,
	addDay,
	getAppointedDate,
	getDiffDate,
	weekStart,
	weekEnd,
	} from "../../../util/DateUtil";
import * as echarts from 'echarts';
export default {
    data(){
        return {
            pickerOptions: {
				firstDayOfWeek: 1,
				disabledDate(time) {
					return time.getTime() > Date.now();
				},
			},
            date: new Date(),
			radio: "day",
        }
    },
    computed: {
		nextDayDisabled() {
			let timestamp = dateFormat("YY-mm-dd", new Date());
			let endtime = dateFormat("YY-mm-dd", this.date);
			if (this.radio === "year") {
				timestamp = dateFormat("YY", new Date());
				endtime = dateFormat("YY", this.date);
			} else if (this.radio === "month") {
				timestamp = dateFormat("YY-mm", new Date());
				endtime = dateFormat("YY-mm", this.date);
			} else if (this.radio === "week") {
				timestamp = dateFormat("YY-mm-dd", new Date());
				endtime = dateFormat("YY-mm-dd", addDay(this.date, 5));
			}
			if (endtime >= timestamp) {
				return true;
			} else {
				return false;
			}
		},
    },
    watch:{
        date(val){
            this.$emit('sendTime', dayStart(val).split('T')[0])
        }
    },
    mounted(){
        this.$emit('sendTime', dayStart(this.date).split('T')[0])
    },
    methods:{
        perW() {
			let week = getAppointedDate(this.date, 1, 1);
			this.date = new Date(week.startDate);
		},
		nextW() {
			let week = getAppointedDate(this.date, 1, -1);
			this.date = new Date(week.startDate);
		},
		perD() {
			// console.log(this.date);
			this.date = perDay(this.date);
		},
		nextD() {
			this.date = nextDay(this.date);
		},
		perM() {
			this.date = perMonth(this.date);
		},
		nextM() {
			this.date = nextMonth(this.date);
		},
		perY() {
			this.date = perYear(this.date);
		},
		nextY() {
			this.date = nextYear(this.date);
		},
    }
}
</script>

<style lang="less" scoped>
.selectTime{
    width: 100%;
    height: 100%;
    justify-content: flex-start;
    .dateSelect {
        margin-right: 10rem;
        }

    .per {
        margin-left: 10rem;
        }

    .el-radio {
        margin-right: 20rem;
    }
}

</style>